
import Vue from "vue";
import "font-awesome/css/font-awesome.min.css";
//import hub from "@/assets/js/bus";
import LoginApis from "@/api/loginApis";
import Component from "vue-class-component"; // 导入组件装饰器
// import { mapGetters, mapMutations } from "vuex";
@Component({})
export default class Navbar extends Vue {
  name = "navbar";

  sysName = "纽锐拓消费者指数小程序";
  sendMsg = "";
  userName = "";
  collapsed = false;
  activeIndex = "1";
  isLoading = false;
  dialogFormVisible = false;
  isDisabled = false;
  form = {
    oldPass: "",
    pass: "",
    checkPass: "",
  };
  isCurrentForm = {
    isCurrent: null,
    appId: "",
  };
  // publicTitle: "",
  // publicName: this.publicTitle.name,
  queryForm = {
    name: "",
    currentPageIndex: null,
    pageSize: null,
    sortField: "Id",
  };
  currentPublic = "";
  wxPublics = {
    tableData: [],
  };
  rule = {
    oldPass: [
      {
        required: true,
        message: "请输入旧密码",
        trigger: "blur",
      },
      {
        min: 6,
        max: 18,
        message: "长度在 6 到 18 个字符",
        trigger: "blur",
      },
    ],
    pass: [
      {
        required: true,
        validator: (rule, value, callback) => {
          if (value === "") {
            callback(new Error("请输入密码"));
          } else {
            if (this.form.checkPass !== "") {
              this.$refs.form.validateField("checkPass");
            }
            callback();
          }
        },
        trigger: "blur",
      },
      {
        min: 6,
        max: 18,
        message: "长度在 6 到 18 个字符",
        trigger: "blur",
      },
    ],
    checkPass: [
      {
        required: true,
        validator: (rule, value, callback) => {
          if (value === "") {
            callback(new Error("请再次输入密码"));
          } else if (value !== this.form.pass) {
            callback(new Error("两次输入密码不一致!"));
          } else {
            callback();
          }
        },
        trigger: "blur",
      },
      {
        min: 6,
        max: 18,
        message: "长度在 6 到 18 个字符",
        trigger: "blur",
      },
    ],
  };
  formLabelWidth = "120px";
  setLoginCookieUrl = "";

  created() {
    // 当前站点登录跳转后 异步通知权限服务器写登录cookie
    this.setLoginCookieUrl = sessionStorage.getItem("setLoginCookieUrl");
    sessionStorage.removeItem("setLoginCookieUrl");

    let user = JSON.parse(sessionStorage.getItem("user"));
    this.userName = user.userName;
  }

  // 回到首页点击触发事件
  goHeadPage() {
    console.log(this.$root.Bus);
    this.$root.Bus.$emit("send", this.sendMsg);
  }

  // Dropdown触发显示列表事件
  handleDropdownChange(val) {
    if (val) {
      this.getPublic();
    }
  }
  // 右侧用户头像下拉菜单事件
  onCommand(cmd) {
    if (cmd === "q") {
      this.logOut();
    }
    if (cmd === "changePwd") {
      this.dialogFormVisible = true;
    }
  }
  // 修改密码提交事件
  onSubmit(formName) {
    this.$refs[formName].validate((valid) => {
      if (valid) {
        this.isLoading = true;
        let data = {
          oldPass: this.form.oldPass,
          newPass: this.form.pass,
        };

        LoginApis.changePwd(data)
          .then((res) => {
            this.$message.success("密码修改成功");
            this.isLoading = false;
            this.dialogFormVisible = false;
          })
          .catch((error) => {
            let data = error.response.data;
            this.isLoading = false;
            this.$message.error(data.message);
          });
        // alert('submit!')
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }
  // 退出登录事件
  logOut() {
    console.log("000");
    LoginApis.logout().then((res) => {
      console.log("111", res);
      debugger;
      window.sessionStorage.setItem("__TOKEN_KEY__", "");
      window.sessionStorage.setItem("user", "");
      window.sessionStorage.setItem("menuList", "");
      window.sessionStorage.setItem("hasEnableAppId", "");

      let payLoad = res.data.payLoad;
      let setLogOutCookieUrl = process.env.Logout_URL + payLoad;

      // 当前站点退出后-跳转到登录页前-设置异步通知权限服务器用到的参数
      sessionStorage.setItem("setLogOutCookieUrl", setLogOutCookieUrl);
      sessionStorage.setItem("isSetLogOutCookieUrl", 0);

      // 跳转到登录页
      this.$router.push({
        path: "/login",
      });
    });
  }
  collaspe() {
    this.collapsed = !this.collapsed;
    this.$root.Bus.$emit("change", this.collapsed);
  }
}
